var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_39275",
    "data-name": "Group 39275",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.487,
    height: 16.519,
    viewBox: "0 0 16.487 16.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28634",
    "data-name": "Path 28634",
    d: "M-2116.943-1076.481h-9.982a3.1,3.1,0,0,1-.455-.147,1.44,1.44,0,0,1-.833-1.394q0-4.323,0-8.646,0-2.4,0-4.791a1.41,1.41,0,0,1,.6-1.251,3.724,3.724,0,0,1,.686-.291h8.147a1.951,1.951,0,0,1,1.066.613c.5.489,1.005.969,1.516,1.444a1.644,1.644,0,0,1,.543,1.275c-.007,1.462,0,2.924,0,4.386v.2c.062-.07.094-.106.125-.142.405-.48.807-.963,1.216-1.44a1.435,1.435,0,0,1,2.389.178,3.164,3.164,0,0,1,.2.519v.387a2.073,2.073,0,0,1-.447.875q-1.7,2-3.38,4.014a.46.46,0,0,0-.1.27c-.007.805,0,1.611,0,2.417a1.4,1.4,0,0,1-.6,1.233A3.769,3.769,0,0,1-2116.943-1076.481Zm-2.576-15.545c-.045,0-.076-.006-.107-.006q-3.55,0-7.1,0a.486.486,0,0,0-.521.542q0,6.75,0,13.5a.489.489,0,0,0,.539.54h9.546a.49.49,0,0,0,.54-.539c0-.441,0-.882,0-1.323,0-.04,0-.079-.008-.122-.144.079-.27.161-.405.221-.553.245-1.11.483-1.665.726a.5.5,0,0,1-.571-.058.508.508,0,0,1-.135-.547q.207-.861.409-1.723a1.73,1.73,0,0,1,.371-.741q.954-1.124,1.9-2.256a.459.459,0,0,0,.1-.269c.006-1.624,0-3.247,0-4.871v-.177h-2.324a.5.5,0,0,1-.574-.57q0-1.073,0-2.145Zm5.042,7.054-2.669,3.164.739.622,2.667-3.166Zm-2.252-5.131-1.815-1.736v1.736Zm2.875,4.39.738.621c.11-.132.219-.25.314-.377a.474.474,0,0,0-.072-.675.471.471,0,0,0-.662.06C-2113.641-1085.971-2113.738-1085.849-2113.854-1085.713Zm-3.183,5.262-.728-.613c-.395.357-.33.868-.474,1.312C-2117.835-1079.981-2117.321-1080-2117.037-1080.451Z",
    transform: "translate(2128.214 1093)",
    fill: "#4b96cd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28635",
    "data-name": "Path 28635",
    d: "M-2075.938-947.25q-1.908,0-3.815,0a.483.483,0,0,1-.5-.641.468.468,0,0,1,.421-.324,1.468,1.468,0,0,1,.161,0h7.47c.386,0,.611.178.611.484s-.225.484-.611.484Z",
    transform: "translate(2082.218 954.057)",
    fill: "#4b96cd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28636",
    "data-name": "Path 28636",
    d: "M-2075.97-875.232q-1.9,0-3.8,0a.484.484,0,0,1-.5-.654.472.472,0,0,1,.4-.309.776.776,0,0,1,.113,0h7.6a.749.749,0,0,1,.191.02.478.478,0,0,1,.357.493.486.486,0,0,1-.43.45,1.568,1.568,0,0,1-.177,0Z",
    transform: "translate(2082.236 884.944)",
    fill: "#4b96cd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28637",
    "data-name": "Path 28637",
    d: "M-2077.385-1021.017c.789,0,1.578,0,2.367,0a.483.483,0,0,1,.481.656.48.48,0,0,1-.465.31c-.365,0-.73,0-1.095,0q-1.835,0-3.67,0a.485.485,0,0,1-.5-.656.492.492,0,0,1,.5-.31Q-2078.576-1021.019-2077.385-1021.017Z",
    transform: "translate(2082.231 1023.921)",
    fill: "#4b96cd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28638",
    "data-name": "Path 28638",
    d: "M-2077.4-803.254c-.789,0-1.578,0-2.366,0a.483.483,0,0,1-.486-.652.482.482,0,0,1,.462-.313c.225,0,.451,0,.676,0q2.045,0,4.089,0a.486.486,0,0,1,.5.653.49.49,0,0,1-.495.314Q-2076.211-803.252-2077.4-803.254Z",
    transform: "translate(2082.22 815.869)",
    fill: "#4b96cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodes);
export default __webpack_public_path__ + "static/media/nodes.624ad543924f79a2fae60830db110239.svg";
export { ForwardRef as ReactComponent };